import { Component } from 'vue-property-decorator'
import ClvrScreenControlInterventionCell from './ClvrScreenControlInterventionCell/ClvrScreenControlInterventionCell.vue'
import ClvrScreenControlPatientCell from './ClvrScreenControlPatientCell/ClvrScreenControlPatientCell.vue'
import ClvrScreenControlMaterialAndRemarkNoteCell from './ClvrScreenControlMaterialAndRemarkNoteCell/ClvrScreenControlMaterialAndRemarkNoteCell.vue'
import ClvrScreenControlInterventionScheduleCell from './ClvrScreenControlInterventionScheduleCell/ClvrScreenControlInterventionScheduleCell.vue'
import ClvrScreenControlMaterialCell from './ClvrScreenControlInterventionCell/ClvrScreenControlInterventionCell.vue'
import ClvrScreenControlOperatingRoomStaff from './ClvrScreenControlOperatingRoomStaff/ClvrScreenControlOperatingRoomStaff.vue'
import ClvrScreenControlDefaultCell from './ClvrScreenControlDefaultCell/ClvrScreenControlDefaultCell.vue'
import ClvrScreenControlInterventionStatus from './ClvrScreenControlInterventionStatus/ClvrScreenControlInterventionStatus.vue'
import ClvrScreenControlInterventionMaterialCell from './ClvrScreenControlInterventionMaterialCell/ClvrScreenControlInterventionMaterialCell.vue'
import { ClvrScreenControlCellComponentsInterface } from '../interface/ClvrScreenControlCellComponentsInterface'
import { ClvrScreenControlMappingMethodType } from '../type'
import ClvrScreenControlCellComponent from './ClvrScreenControlCell'
import { ClvrScreenControlDataRelationsPropsInterface } from '../interface'
import {
    CELL_COMPONENTS_MAPPING,
    DEFAULT_COMPONENT,
    DEFAULT_PROP as DEFAULT_PROP_SCREEN_CONTROL,
} from './ClvrScreenControlDefaultMapping'
import { Undefinable } from '@internal-libraries/kheops-ui-lib'

@Component({
    components: {
        ClvrScreenControlInterventionCell,
        ClvrScreenControlPatientCell,
        ClvrScreenControlMaterialAndRemarkNoteCell,
        ClvrScreenControlInterventionScheduleCell,
        ClvrScreenControlMaterialCell,
        ClvrScreenControlOperatingRoomStaff,
        ClvrScreenControlDefaultCell,
        ClvrScreenControlInterventionStatus,
        ClvrScreenControlInterventionMaterialCell,
    },
})
export default class ClvrScreenControlRowCell extends ClvrScreenControlCellComponent {
    public get componentCellUse(): Undefinable<ClvrScreenControlCellComponentsInterface> {
        return CELL_COMPONENTS_MAPPING[this.cellType]
    }

    public get componentForDataType(): string {
        return this.componentCellUse?.component ?? DEFAULT_COMPONENT
    }

    // allows you mapping props for the child component
    public get propsMapping(): Record<string, string> {
        // retrieval of prop relations in CELL_COMPONENTS_MAPPING for the current cell
        const labelsMappingProps: Undefinable<Record<string, ClvrScreenControlDataRelationsPropsInterface>> =
            this.componentCellUse?.dataRelationProps
        // will contain the props data, in fact we use vuejs components to create for the control
        // screen and these components have props with generic names such as 'label', 'txt', etc.
        const props = {}

        if (labelsMappingProps) {
            Object.entries(labelsMappingProps).forEach(([headername, propMapping]): void => {
                // Each data expected in the cell is either from the raw information display or it can contain a different
                // logic such as the combined display of data, if the data displayed needs a customized display we check if it contains
                // a customMapping method if yes we call it
                const propsNameRef: string = propMapping['propName'] ?? DEFAULT_PROP_SCREEN_CONTROL['propName']
                const mappingMethod: ClvrScreenControlMappingMethodType = propMapping.customMapping

                if (this.interventionData) {
                    props[propsNameRef] = mappingMethod(this.interventionData)
                } else {
                    props[propsNameRef] = ''
                }
            })
        }
        return props
    }
}
